<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../../assets/images/htgl2.png" class="steps step1" v-if="status==1">
      <img src="../../../assets/images/htgl1.png" class="steps step2" v-if="status==2">
      <div class="stepbtn" @click="nextStep(status)">
        {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'新建线下合同'}]"/>
    <div class="h-content" :class="{'ljjtips':true}">
      <div class="h-piece">
        <div class="outerCon">
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '1'}" @click="tabchange(1)">合同</div>
          <div class="tabBtn" :class="{tabBtnAc:tabIndex == '3'}" @click="tabchange(3)">关联订单</div>
        </div>
        <div class="h-formLine weekplandetail23" v-show="tabIndex == '1'">
          <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
            <h1>合同详情</h1>
          </div>
          <el-form label-position="right" :model="formInline" ref="form1" :inline="true"  class="demo-ruleForm h-formbLine">
            <el-form-item label="合同编码" class="h-elformWrap-2" prop="id">
              <el-input v-model="formInline.id" placeholder="请输入合同名称" disabled></el-input>
            </el-form-item>
            <el-form-item label="合同名称" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractName"></el-input>
            </el-form-item>
            <el-form-item label="合同类型" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.contractCatecoryName"></el-input>
            </el-form-item>
            <el-form-item label="客户名称" class="h-elformWrap-2">
              <el-input readonly v-model="formInline.customerName"></el-input>
            </el-form-item>
            <el-form-item label="销售渠道" class="h-elformWrap-2" prop="salechannelCode">
              <brselect category="sales_region" :v="formInline.salechannelCode" v-model="formInline.salechannelCode" disabled style="width:3.1rem"/>
            </el-form-item>
            <el-form-item label="销售省区" class="h-elformWrap-2 w-elformWrap" prop="saleareaCode">
              <brselect category="YlSalesArea_chanpin" :v="formInline.saleareaCode"
                        v-model="formInline.saleareaCode" disabled></brselect>
            </el-form-item>
          </el-form>
          <div class="h-formLine h-mrt40 weekplandetail1">
            <el-form label-position="right" :inline="true"  class="demo-ruleForm h-formbLine">
              <el-form-item label="合同附件" class="h-elformWrap-1 h-formRbtnOut h-formRbtnOut2" style="width: 100%;" prop="name">
<!--                <brupload :refid="this.contractId" reftype="合同附件" :uploadflag="false" :delflag="false"
                          :tpFlag = 'true' :isTpAndPdf = 'true'
                ></brupload>-->
                <el-button
                  @click="lookPdf"
                  type="text"
                  size="small"
                  class="h-tableLink h-btn">
                查看附件
              </el-button>

              </el-form-item>


            </el-form>
          </div>
          <div style="text-align: center;margin-top: 0.3rem">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
          </div>
        </div>
        <div class="h-formLine weekplandetail" v-show="tabIndex == '3'">
          <div class="h-piece" style="padding: 10px">
            <el-form :inline="true" :model="contractOrderFrom" class="demo-form-inline h-formBorder">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="订单号">
                  <el-input v-model="contractOrderFrom.sapCode" clearable placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="产品编码">
                  <el-input v-model="contractOrderFrom.materialCodeNameLike" clearable placeholder="请输入产品编码或名称"></el-input>
                </el-form-item>
                <el-form-item class="right-btn">
                  <el-button class="h-btn h-formBtn" @click="contractOrderPage">检索</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <el-table :data="contractOrderData" :border="true" max-height="560" style="width: 100%" ref="multipleTable">
            <el-table-column label="序号" type="index" fixed width="50"></el-table-column>
            <el-table-column fixed label="合同编号" width="120px" show-overflow-tooltip>
              <template scope="scope">
                <div style="text-align: left;">
                  {{scope.row.contractNo || scope.row.orderMainContract}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sapCode" label="订单号" width="110px" fixed show-overflow-tooltip></el-table-column>
            <el-table-column prop="soldToName" label="售达方名称"  :show-overflow-tooltip="true" width="180">
              <template scope="scope">
                <div style="text-align: left;">
                  {{scope.row.soldToName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="soldToCode" label="售达方编码" :show-overflow-tooltip="true" width="110"></el-table-column>
            <el-table-column
                prop="soldToAreaName"
                label="售达方地区"
                :show-overflow-tooltip="true"
                width="110">
            </el-table-column>
            <el-table-column
                prop="materialName"
                label="产品名称"
                :show-overflow-tooltip="true"
                width="140">
              <template scope="scope">
                <div style="text-align: left;">
                  {{scope.row.materialName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="oemDesc"
                label="规格型号"
                width="140"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="proNumber"
                label="数量"
                width="60">
              <template scope="scope">
                <div style="text-align: right;">
                  {{scope.row.proNumber}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="prodtype"
                label="自产/OEM"
                width="100">
            </el-table-column>
            <el-table-column
                prop="spbmjcmtlgroupname"
                label="开票名称"
                width="240"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="shareModelName"
                label="共享大类"
                width="100">
              <template scope="scope">
                <div style="text-align: center;">
                  {{scope.row.shareModelName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="isZhidan"
                label="经销商类型"
                :show-overflow-tooltip="true"
                width="110">
              <template scope="scope">
                {{scope.row.isZhidan|dictname('dailishang_leixing')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="secondLevelAgentName"
                label="分销商名称"
                :show-overflow-tooltip="true"
                width="120">
            </el-table-column>
            <el-table-column
                prop="secondSapCode"
                label="分销商订单号"
                width="100">
            </el-table-column>
            <el-table-column
                prop="materialCode"
                label="产品编码"
                :show-overflow-tooltip="true"
                width="110">
            </el-table-column>
            <el-table-column
                prop="status"
                label="订单状态"
                :show-overflow-tooltip="true"
                width="110">
              <template scope="scope">
                {{scope.row.status|dictname('order_status')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="saleGroupCode"
                label="销售组织"
                :show-overflow-tooltip="true"
                width="260">
              <template scope="scope">
                <div style="text-align: left;">
                  [{{scope.row.saleGroupCode}}]{{scope.row.saleGroupCode|dictname('YLSalesOrganization_agent')}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="customerChannelCode"
                label="客户渠道"
                :show-overflow-tooltip="true"
                width="90">
              <template scope="scope">
                {{scope.row.customerChannelCode|dictname('sales_region')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="orderProjectName"
                label="项目名称"
                :show-overflow-tooltip="true"
                width="180">
              <template scope="scope">
                <div style="text-align: left;">
                  {{scope.row.orderProjectName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
            prop="wldw"
            label="单位"
            width="70">
            </el-table-column>
            <el-table-column
                prop="finalPrice"
                label="成交价"
                :show-overflow-tooltip="true"
                width="80">
              <template scope="scope">
                <div style="text-align: right;">
                  {{scope.row.finalPrice}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="totalprice"
                label="总价"
                :show-overflow-tooltip="true"
                width="80">
              <template scope="scope">
                <div style="text-align: right;">
                  {{scope.row.totalprice}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jinejjz"
                label="不含税总价"
                :show-overflow-tooltip="true"
                width="110">
              <template scope="scope">
                <div style="text-align: right;">
                  {{scope.row.jinejjz}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="totalprice"
                label="汇算总价"
                :show-overflow-tooltip="true"
                width="90">
              <template scope="scope">
                <div style="text-align: right;">
                  {{scope.row.totalprice}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="thawStatus"
                label="签收状态"
                :show-overflow-tooltip="true"
                width="60">
              <template scope="scope">
                <span v-if="scope.row.thawStatus == 'Y'">已签收</span>
                <span v-if="scope.row.thawStatus == 'N'">未签收</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="acceptTime"
                label="签收时间"
                :show-overflow-tooltip="true"
                width="100">
            </el-table-column>
            <el-table-column
                prop="cuname"
                label="创建人名称"
                :show-overflow-tooltip="true"
                width="110">
            </el-table-column>
            <el-table-column
                prop="cdate"
                label="创建时间"
                width="160">
            </el-table-column>
          </el-table>
          <div class="h-tableB h-mrt30">
            <div class="h-pagination2">
              <pagination :page="contractOrderFrom" @query="contractOrderPage"/>
            </div>
          </div>
        </div>

          <el-dialog :visible.sync="lookPdfflag" width="100%">
              <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
          </el-dialog>

      </div>
    </div>
  </div>
</template>
<script>
  import ss from "@/api/SystemService";

  export default {
    data() {
      return {
        showOrhide:false,
        checked:true,
        toshow:"contract-agent.vue",
        status:1,
        tabIndex:1,
        contractOrderData:[],
        //表单
        formInline:{
          zltype:"",
          contractName:null,
          pid:"",
          customerCode:"",
          salechannelCode:null,
          contractCatecory:"CT-DLS-KJ",
          contractAmount:"",
          contractStatus:"",
          contractStarttime:"",
          contractEndtime:"",
          contractCashPledge:"",
          productCode:"",
          productName:"",
          productPrice:"",
          productType:"",
          rentNum:"",
          rentTime:"",
          guaranteeTime:"",
          productList:[],
          zsyzq:"",
          rentType:"",
          isShhm:0,
          isJj:0,
          rentPlace:"",
          returnPlace:"",
          rentPrice:"",
          contractAgent:"",
          auditMind2:"",
          status:"",
          isZc:"",
          saleareaCode:null,
          bscContractAgentAddList:[],
          salesCity:"",
        },
          pdfUrl:null,
          lookPdfflag: false,

        contractOrderFrom:{
          //合同编码
          orderMainContract:this.$route.query.key,
          //产品编码或名称
          materialCodeNameLike:null,
          //订单号
          sapCode:null,
          pageSize: 10,
          pageNo: 1,
          total: 0,
        },
        contractId: this.$route.query.key,
      }
    },
    created() {
      ss.contractService.detail(this.contractId).then(rd=>{
        this.formInline = rd.obj;
        this.contractOrderPage();
        this.formInline.id = this.contractId;
      })
    },
    methods: {
// 关闭新手引导页
      closeIt(){
        this.showOrhide = false;
        if(this.checked){
          ss.salesList.toshow(this.toshow,this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }else{
          ss.salesList.toshow(this.toshow,this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      },
      nextStep(i){
        if(this.status ==1){
          this.status = 2;
        }else if(this.status ==2){
          if(this.checked){
            ss.salesList.toshow(this.toshow,this.checked).then(rd => {
              console.log(rd)
              this.showOrhide = false;
            })
          }else{
            ss.salesList.toshow(this.toshow,this.checked).then(rd => {
              console.log(rd)
              this.showOrhide = false;
            })
          }
        }
      },
      tabchange(i) {
        console.log(i);
        this.tabIndex = i;
        if (this.tabIndex == '1') {
          this.tabflag = true;
        } else if (this.tabIndex == '3') {
          this.tabflag = true;
        } else if (this.tabIndex == '2') {
          this.tabflag = true;
        }
      },
      uploadFile(){
        let data = {};
        data.orderMainContract = this.$route.query.key;
        ss.OrderMainService.testprintDispatchBill(data).then(res => {
          let link = document.createElement('a')
          let blob = new Blob([res], {type: 'application/pdf'});
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob);
          //link.setAttribute('download')
          link.setAttribute('download', `销售合同.pdf`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

        }).catch((e) => {
          console.log(e)
          this.$alert("下载失败", '提示', {
            confirmButtonText: '确定',
          });
        });
      },
      cancel(){
        this.$router.push("contract-list");
      },
        //在线查看pdf测试地址
        lookPdf(){
          let arr = [];
          for (let i = 0; i < this.contractOrderData.length; i++) {
            arr.push(this.contractOrderData[i].sapCode)
          }
            ss.OrderMainService.supplementlater(arr).then(rd => {
                const blob = new Blob([rd], { type: 'application/pdf' })
                this.pdfUrl = URL.createObjectURL(blob)
                this.lookPdfflag= true;
             })
      //      window.open(process.env.VUE_APP_AJAXURL+"/api/swyl/v1/demo/bscPartnerHighSeas/taskTest",'_blank');



        },
      contractOrderPage(){
        ss.OrderMainService.associationOrderPage(this.contractOrderFrom).then(rd => {
          this.contractOrderData = rd.records;
          this.contractOrderFrom.total = rd.total || 0;
        });
      },
    }
  }
</script>
<style>
 .el-upload-list__item-name:hover {
    cursor: pointer;
 }
.yearIcon .el-input:after {
  content: '天';
  font-size: 0.18rem;
  color: #b8b6b6;
  /* font-weight: bold; */
  position: absolute;
  right: 0.15rem;
}
.weekplandetail1 .h-formbLine .el-form-item__label{
  width: 11%;
  text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__label{
  width: 34%;
  text-align: right;
}
.weekplandetail23 .h-formbLine .el-form-item__content{
  width: 66%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-2{
  width: 33.333%;
  padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1{
  width: 100%;
  padding-right: 0.5rem
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__label{
  width: 10.4%;
}
.weekplandetail23 .h-formbLine .h-elformWrap-1 .el-form-item__content{
  width: 89.6%;
}
.ljjtips .el-table tbody td .cell{
  padding: 0.2rem 0.1rem;
}
.outerCon {
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #dae0f0;
  width: 100%;
  margin-bottom: 30px;


  .tabBtn {
    background-color: #f0f5fb;
    padding: 10px;
    border: 1px solid #dae0f0;
    margin-right: 10px;
    color: #282c2f;
    cursor: pointer;
  }

  .tabBtnAc {
    color: white;
    background-color: #2785e7;
  }
  .foundation-box{
    font-size: 0.18rem;
    color: #868686;
    line-height: 0.28rem;
  }
  .signsign .h-formbLine .el-form-item__label {
    width: 39%;
  }

  .zhanghu .h-formbLine .el-form-item__content,
  .signsign .h-formbLine .el-form-item__content {
    width: 52%;
  }

  .zhanghu .h-formbLine .h-elformWrap-2,
  .signsign .h-formbLine .h-elformWrap-2 {
    width: 25%;
    padding-right:0
  }

}
</style>
<style scoped lang="scss">
.bottomTip{
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}
.newtext{
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top:0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow:1px 1px 4px #2785E7;
  z-index: 2;
}
.leaderBox{
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;
  .leaderbg{
    width: 100%;
    height: 100%;
  }
  .steps{
    position: absolute;
    z-index: 1;
  }
  .step1{
    top: 2.6rem;
    left: 3.15rem;
    width: 4rem;
    height: 1.7rem;
  }
  .step2{
    top: 4.55rem;
    left: 3.9rem;
    width: 13.5rem;
    height: 2.3rem;
  }

  .stepbtn{
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0,0,0,0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }
  .closeIt{
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
